import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { StorageManagerService } from '../../_provider/storage-manager.service';
import { DarkmodeService } from '../../_provider/darkmode.service';
import { FeedbackService } from "../../_provider/feedback.service"
import { HttpService } from "../../_provider/http.service"
import { GeneralService } from '../../_provider/general.service';
// import { Zeroconf } from '@awesome-cordova-plugins/zeroconf/ngx';
// var bonjour = require('bonjour')()
import { Zeroconf } from "@ionic-native/zeroconf";
import { Subscription } from 'rxjs';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { environment } from 'src/environments/environment';
import { SentryPage } from '../new-settings/sentry/sentry.page';
import { SentryService } from 'src/app/_provider/sentry/sentry.service';
import { ImpactStyle } from '@capacitor/haptics';

export interface MulticatItem{
  hostname?: string,
  ipv4?: string,
  port?: number
  domainName?: string
} 

export enum SetupResult{
  NormalFinish,
  DemoMode,
  QRCode
}


@Component({
    selector: 'app-setup',
    templateUrl: './setup.page.html',
    styleUrls: ['./setup.page.scss'],
    standalone: false
})
export class SetupPage implements OnInit {
 
  // @ViewChild(IonSlides, {static: true}) slides: IonSlides
 
  public serverAddress: string = ""
  public port: number
  //public camesFromQR: boolean = false
 
  public colorAnimate: boolean = false
  public serverList: MulticatItem[] = []
  private multicastSub: Subscription
  public isSentryEnabled: boolean = true

  public allowSwipe: boolean = false
 
  @ViewChild('swiper') swiperRef: any;

  public slideOpts = {  
    initialSlide: 0,
    speed: 400
  };

  constructor(
    public darkmode: DarkmodeService,
    private feedback: FeedbackService,
    private http: HttpService,
    private generalSrv: GeneralService,
    private changeDetector: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private sentrySrv: SentryService,
    private storageManager: StorageManagerService,
    public platform: Platform,
  ) { 

  }  
  
  async ngOnInit() {
    // if(this.camesFromQR) {
    //   await this.next()
    //   await this.setupNext()
    // }
    // this.slides.lockSwipes(true)
    
  } 

  public async next(){ 
    this.allowSwipe = true
    this.changeDetector.detectChanges()
    this.swiperRef?.nativeElement?.swiper.slideNext()
    this.allowSwipe = false
  } 
 
 
  private connectTry: number = 1
  private connectUrl: string = ""
  public async setupNext(){
    //http wegschneiden damit zuerst mit https getestet werden kann
    if(this.serverAddress?.startsWith("http://")) this.serverAddress = this.serverAddress.replace("http://", "")
    if(this.serverAddress?.startsWith("https://")) this.serverAddress = this.serverAddress.replace("https://", "")

    if(this.connectTry == 1){ 
      await this.feedback.updateLoading("Teste Verbindung...")
      this.connectUrl = `https://${this.serverAddress}/api/`
      this.http.defaultURL = `https://${this.serverAddress}/api/`
    }else if(this.connectTry == 2){
      this.connectUrl = `http://${this.serverAddress}/api/`
      this.http.defaultURL = this.connectUrl
    }else {
      await this.feedback.hideLoading()
      await this.feedback.showError("Keine Verbindung möglich. Bitte versuchen sie eine andere Server-Adresse.")
      this.connectTry = 1
      return
    }

    const result: HttpFunctionResult<any> = await this.http.GET<any>({
      path: "",
      handleError: false,
      asDataProperty: false,
      timeout: 4000
    })
    if(!result.success){ 
      this.connectTry++
      return await this.setupNext() 
    }
      
    await this.storageManager.setItem<string>("BASEURL", this.connectUrl)
    await this.feedback.hideLoading()
    this.connectTry = 1
    if(this.connectUrl.startsWith("http://")) {
      if(!(await this.feedback.confirm('Die Verbindung zu diesem Server ist unsicher, da sie nicht über "https" erreichbar ist. Möchten Sie trotzdem fortfahren?', "Weiter", "Abbrechen"))){
        await this.storageManager.delete("BASEURL")
        return
      }
    }
    if(this.connectUrl != environment.demoServer) await this.storageManager.setItem("COMPANY_IDENTIFIER", result.data.companyIdentifier)
    await this.next()

  }
  
  public async finish(setupResult: SetupResult = SetupResult.NormalFinish){
    if(setupResult == SetupResult.DemoMode){
      await this.modalCtrl.dismiss(setupResult) 
      return
    }else if(setupResult == SetupResult.QRCode){
      const qrResult: HttpFunctionResult<string> = await this.feedback.getQRCodeData()
      if(!qrResult.success) return
      this.serverAddress = qrResult.data
      
      if(await this.swiperRef.nativeElement?.swiper?.activeIndex == 0) await this.next()
       
      return await this.setupNext()
    }
    if(this.multicastSub) this.multicastSub.unsubscribe()
    await this.feedback.updateLoading("Abschließen...")
    await this.sentrySrv.toggleSentryEnabled(this.isSentryEnabled, true)
    await this.sentrySrv.loadSentryEnabled()
    await this.storageManager.setItem<boolean>("SETUPCOMPLETE", true)
    await this.feedback.hideLoading()
    await this.modalCtrl.dismiss(setupResult) 
  }  
   
  async toServerConfig(){
    this.next()  
    // setInterval(()=>Zeroconf.reInit(), 5000)
    setTimeout(() => { 
      // Zeroconf.registerAddressFamily = 'ipv4';
      // Zeroconf.watchAddressFamily = 'ipv4'; 
      this.multicastSub = Zeroconf.watch("_TicketsystemAPI._tcp.", "local.").subscribe(result => {
        console.log(result.service);
        if(result.action == "resolved"){ 
          console.log(result.service);
          
          if(!result.service.txtRecord.hostname || !result.service.ipv4Addresses[0]) return
          if(this.serverList.find(s => s.hostname == result.service.txtRecord.hostname)){
            this.serverList[this.serverList.findIndex(s => s.hostname == result.service.txtRecord.hostname)] = {
              hostname: result.service.txtRecord.hostname, 
              ipv4: result.service.ipv4Addresses[0], 
              port: result.service.port,
              domainName: result.service.txtRecord.domainname
            }  
          }else{  
             this.serverList.push({ 
              hostname: result.service.txtRecord.hostname,   
              ipv4: result.service.ipv4Addresses[0],  
              port: result.service.port, 
              domainName: result.service.txtRecord.domainname 
            })    
          }     
        }    
        this.changeDetector.detectChanges()  
      }, (err)=>console.error(err));  
    }, 400);  
  } 

  public async selectServerByList(server: MulticatItem){
    this.feedback.vibrate(ImpactStyle.Medium) 
    this.serverAddress = `${server.domainName ? server.domainName : (server.ipv4 ? server.ipv4 : server.hostname)}:${server.port}`
    this.changeDetector.detectChanges()
    await this.setupNext()  
  }  

  public async openSentryText(){
    await this.feedback.openModal(SentryPage, {isModal: true, onlyText: true})
  }

}                   